var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgParagraph(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    fill: "none",
    viewBox: "0 0 25 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    fill: "#464646",
    rx: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M6.923 17V7.9H10.108C10.8187 7.9 11.408 8.02133 11.876 8.264C12.344 8.498 12.6907 8.823 12.916 9.239C13.15 9.64633 13.267 10.11 13.267 10.63C13.267 11.124 13.1543 11.579 12.929 11.995C12.7123 12.4023 12.37 12.7273 11.902 12.97C11.434 13.2127 10.836 13.334 10.108 13.334H8.301V17H6.923ZM8.301 12.203H10.043C10.693 12.203 11.1567 12.0643 11.434 11.787C11.72 11.501 11.863 11.1153 11.863 10.63C11.863 10.1273 11.72 9.73733 11.434 9.46C11.1567 9.174 10.693 9.031 10.043 9.031H8.301V12.203ZM15.5651 17V9.46L14.0961 9.798V8.784L16.1111 7.9H16.9951V17H15.5651Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgParagraph);
export default __webpack_public_path__ + "static/media/paragraph.16cb911aeb2f08ce0783b8927adf5a64.svg";
export { ForwardRef as ReactComponent };